let autoComplete,
	$autoCompleteDropdown = null;
const autoCompleteField = document.getElementById('autoComplete'),
	locateButton = document.querySelector('.locate-btn'),
	icon = locateButton.querySelector(' .ion'),
	lngField    = document.getElementById('lng'),
	latField    = document.getElementById('lat'),
	radiusField = document.getElementById('radius'),
	form = document.querySelector('form.quicksearch-module');

function resizeQuickSearch (e)
{
	if ($autoCompleteDropdown === null)
	{
		$autoCompleteDropdown = $('.pac-container');
		$autoCompleteDropdown.on('mouseenter mouseleave', (e) => resizeQuickSearch(e));
	}

	const code = e !== null ? e.keyCode || e.which : false,
		artificialHeight = form.getAttribute('style'),
		hasArtificialHeight = artificialHeight !== null && artificialHeight.match(/[ ;]?height:/);

	//Do not trigger a form submit on enter
	if (code === 13 && artificialHeight)
	{
		e.preventDefault();
	}

	if (($autoCompleteDropdown.length !== 0 || hasArtificialHeight))
	{

		// First remove a set height property
		form.removeAttribute('style');


		//Enter closes the dropdown, so the artificial height should not be added again
		if (code !== 13)
		{
			const height = $autoCompleteDropdown.outerHeight() + $autoCompleteDropdown.offset().top;
			//If the calculated height is higher than the body height set the body to the calculated height
			if (height > $('body').outerHeight(true))
			{
				// Keep a set padding
				const $form = $(form);
				$form.height(height + $form.offset().top - $form.css('padding-top').replace('px', ''));
			}
		}
		const resizeEvent = document.createEvent('HTMLEvents');
		resizeEvent.initEvent('resize', true, false);
		//noinspection JSUnresolvedFunction
		window.dispatchEvent(resizeEvent);
	}
}

function initAutoComplete()
{
	var options  = {
		types: ['geocode'],
		componentRestrictions: {country: "de"},
		fields: ['geometry']
	};
	//noinspection JSUnresolvedVariable
	autoComplete = new google.maps.places.Autocomplete(autoCompleteField, options);
	autoComplete.addListener('place_changed', fillInAddress);
}

function fillInAddress()
{
	if (autoComplete)
	{
		//noinspection JSUnresolvedFunction
		const place = autoComplete.getPlace();
		if (place.geometry)
		{
			const changeEvent = document.createEvent('HTMLEvents');
			changeEvent.initEvent('change', true, false);
			//noinspection JSUnresolvedFunction
			autoCompleteField.dispatchEvent(changeEvent);
			latField.value = place.geometry.location.lat();
			lngField.value = place.geometry.location.lng();
		}
	}
}

if (navigator.geolocation)
{
	$(locateButton).show().click(function ()
	{
		icon.classList.remove('ion-refresh');
		icon.classList.add('ion-ios-location');

		window.ET_Event && ET_Event.click('Immobilien | Schnellsuche | Klick_Standort');

		navigator.geolocation.getCurrentPosition(showPosition);

		function showPosition(position) {
			const lat         = position.coords.latitude,
				lng         = position.coords.longitude;

			autoCompleteField.value = 'Längengrad: ' + lat.toFixed(3) + ' / ' + 'Breitengrad: ' + lng.toFixed(3);

			latField.setAttribute('value', lat.toString());
			lngField.setAttribute('value', lng.toString());
			radiusField.value = 10;

			icon.classList.remove('ion-ios-location');
			icon.classList.add('ion-refresh');
		}
	});
}

autoCompleteField.addEventListener('change', () => {
	latField.value = '';
	lngField.value = '';
});

$(autoCompleteField).on('keydown change click', (e) => resizeQuickSearch(e));

form.addEventListener('submit', () => {
	if (latField.getAttribute('value') === '' || lngField.getAttribute('value') === '')
	{
		latField.removeAttribute('value');
		lngField.removeAttribute('value');
	}
	else if (radiusField.value === '')
	{
		radiusField.val(10);
	}

	window.ET_Event && ET_Event.click('Immobilien | Schnellsuche | Klick_Suche');
});

function syncWithOptionSelect()
{
	const selection        = this.value.toLowerCase(),
		schemaSelect = $('#schema');
	//noinspection JSValidateTypes
	schemaSelect.children('option').each(function ()
	{
		this.value = this.getAttribute('data-value-' + selection);
	});
}

jQuery().ready(function ($)
{
	$("#tradeType").each(syncWithOptionSelect).change(syncWithOptionSelect);
});
